import React from "react";
import { ThemeProvider } from "styled-components";
import {
    StyledHeader,
    StyledSubTitle,
    StyledTitle,
} from "../../styles/MainStyles";
import { TachHistoryProvider } from "../../context/TachContext/TachHistoryContext";
import { SelectTeacherContainer } from "./SelectTeacherContainer";
import { TachHistoryFilters } from "./TachHistoryFilters";
import { TachHistoryTable } from "./TachHistoryTable";

const HistoryTach: React.FC = () => {
    return (
        <ThemeProvider theme={{}}>
            <TachHistoryProvider>
                <StyledHeader>
                    <StyledTitle>Histórico TACH</StyledTitle>
                    <StyledSubTitle>
                        Aqui você pode visualizar e imprimir os TACHs gerados
                        para os professores
                    </StyledSubTitle>
                </StyledHeader>
                <SelectTeacherContainer />
                <TachHistoryFilters />
                <TachHistoryTable />
            </TachHistoryProvider>
        </ThemeProvider>
    );
};

export default HistoryTach;
